import React, {useEffect, useState} from 'react';
import {Button, Form, Modal} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {FormGroup, Icon, Loader, useForm, Yup} from '../components';
import ShowItem from "../ShowItem";
import BoolSelect from "../forms/inputs/BoolSelect";
import OsSelect from "../forms/inputs/OsSelect";
import useActionConfirmation from "../useActionConfirmation";



export const AppGroupModal = ({appGroup, show, setShow, onCreate, onUpdate, onDelete, editable: propEditable = false}) => {
  const { t } = useTranslation();
  const [editable, setEditable] = useState(false)
  const [submitButtonProps, setSubmitButtonProps] = useState({})

  const {Confirmation, confirmationProps, confirm} = useActionConfirmation()

  const handleClose = () => {
    setShow(false);
  }

  useEffect(() => {
    show && setEditable(propEditable)
  },[propEditable, show])

  if (!appGroup && !editable) {
    return <></>
  }


  return (
    <>
      <Modal show={show} onHide={handleClose} size={"lg"}>
        <Modal.Body>
          {!editable && <AppGroupShow appGroup={appGroup}/>}
          {editable && <AppGroupForm
            appGroup={appGroup}
            setSubmitButtonProps={setSubmitButtonProps}
            onSubmit={appGroup ? onUpdate : onCreate}
          />}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => editable ? setEditable(false) : handleClose()}>
            {t("cancel")}
          </Button>
          {!editable && <Button onClick={() => setEditable(true)}>
            <Icon icon='edit' text={t("edit")}/>
          </Button>}
          {editable && <Button key="submit" type="submit" variant="primary" {...submitButtonProps}>
            <Icon icon='save' text={t("save")}/>
          </Button>}
          {appGroup && <Button onClick={() => confirm(onDelete)} variant="primary">
            <Icon icon='trash' text={t("delete")}/>
          </Button>}
        </Modal.Footer>
      </Modal>
      <Confirmation {...confirmationProps} deletion/>
    </>
  );
}

function AppGroupShow({appGroup}) {
  const { t } = useTranslation();

  return <>
    <ShowItem label={t("cmp.appGroups.name")} value={appGroup.name} darkBorder={true} />
    <ShowItem label={t("cmp.appGroups.os")} value={appGroup.os ? t(appGroup.os) : ''} darkBorder={true} />
    <ShowItem label={t("cmp.appGroups.bundleIdMatchers")} value={appGroup.bundleIdMatchers} darkBorder={true} />
    <ShowItem label={t("cmp.appGroups.isDefault")} value={appGroup.isDefault} darkBorder={true} />
  </>
}

function AppGroupForm({appGroup, setSubmitButtonProps, onSubmit}) {
  const { t } = useTranslation();

  const initialValues = {
    name: '',
    os: '',
    bundleIdMatchers: '',
    isDefault: false
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(),
    os: Yup.string().nullable(),
    bundleIdMatchers: Yup.string(),
    isDefault: Yup.string().required()
  })

  const { getInputProps, formProps, formData, handleInputChange } = useForm({
    defaultObject: appGroup,
    initialValues: initialValues,
    validationSchema: validationSchema,
    setSubmitButtonProps: setSubmitButtonProps,
    onSubmit: onSubmit,
  });

  return <Form {...formProps}>
    <FormGroup input="text" label={t("cmp.appGroups.name")} {...getInputProps("name")}/>
    <FormGroup label={t("cmp.appGroups.os")} {...getInputProps("os")}>
      <OsSelect isClearable={true} placeholder={t("cmp.appGroups.selectOs")}/>
    </FormGroup>
    <FormGroup input="text" label={t("cmp.appGroups.bundleIdMatchers")} {...getInputProps("bundleIdMatchers")}/>
    <FormGroup input={BoolSelect} label={t("cmp.appGroups.isDefault")} {...getInputProps("isDefault")}/>
  </Form>
}
